import * as React from "react";
import { Outlet, useParams } from "react-router";

import { useAuth, useNavigation } from "@/providers";
import { LoadingScreen } from "@/shared/components/LoadingScreen";

interface AuthenticationLayoutProps {
  isNotOrgProtected?: boolean;
}

export function AuthenticationLayout({
  isNotOrgProtected,
}: AuthenticationLayoutProps) {
  const {
    initialAuthCheckComplete,
    isAuthenticated,
    isLoading,
    getCurrentOrganization,
  } = useAuth();
  const { goto } = useNavigation();
  const currentOrg = getCurrentOrganization();
  const { inviteId, slackLinkNonce, credentialRequestId } = useParams();

  React.useEffect(() => {
    if (isLoading || !initialAuthCheckComplete) {
      return;
    }

    if (!isAuthenticated) {
      // Pass the route's invitation ID, Slack link nonce, or credential request ID to /signin so
      // sign-in can resume it.
      goto.signIn({ inviteId, slackLinkNonce, credentialRequestId });
    } else if (currentOrg === null && !isNotOrgProtected) {
      goto.signIn({ chooseOrg: true });
    }
  }, [
    initialAuthCheckComplete,
    isAuthenticated,
    isLoading,
    currentOrg,
    isNotOrgProtected,
    goto,
    inviteId,
    slackLinkNonce,
    credentialRequestId,
  ]);

  const orgValid = currentOrg !== null || isNotOrgProtected;

  if (isAuthenticated && orgValid) {
    return <Outlet />;
  } else {
    return <LoadingScreen />;
  }
}
